<template>
  <div>
    <portal target-el="#filter">
      <div class="sub-header">
        <div class="header-item">
          <Breadcrumb type="flex" separator-class="el-icon-arrow-right">
            <breadcrumb-item v-if="orderDetails && !isOrderLoading">
            <span @click="routeToIndentList">{{orderDetails.order_number}}</span></breadcrumb-item>
            <breadcrumb-item>{{$t('INDENT_DOCUMENTS')}}</breadcrumb-item>
          </Breadcrumb>
        </div>
        <div class="header-item f-right" v-if="isMaterialTabSelected && orderDetails && !isOrderLoading">
          <div class="btn-inline">
            <Button
              type="secondary"
              v-if="showEditDeliveryNumbers"
              @click="saveDeliveryNumber">
              {{$t('INDENT_SAVE')}}
            </Button>
            <template v-if="!hasMaterialInvoice && !isDispatched">
              <Button type="secondary" v-permission="['indent_upload_material']">
                <label>
                  <input
                    v-if="isUploadInProcess"
                    class="upload-material"
                    type="file"
                    :accept="`${AttachmentConstants.excelMimes}`"
                    v-on:change="uploadMaterial" />
                  <input else
                    class="upload-material"
                    type="file"
                    :accept="`${AttachmentConstants.excelMimes}`"
                    v-on:change="uploadMaterial" />
                  {{$t('INDENT_UPLOAD')}}
                </label>
              </Button>
            </template>
            <Button
              type="secondary"
              v-permission="['indent_export_materials']"
              @click="downloadMaterial"
            >{{$t('INDENT_DOWNLOAD')}}</Button>
            <Button type="primary" v-if="!isDispatched" @click="loadPlan">{{$t('INDENT_LOAD_PLAN')}}</Button>
            <Button
              type="primary"
              v-if="$hasPermission('trigger_epod') &&
              isMaterialTabSelected && showReTriggerEPOD
              && epod_not_clicked"
              @click="retriggerEpod"
            >{{$t('INDENT_RETRIGGER_EPOD')}}</Button>
            <Button
              type="primary"
              v-else-if="showGrn && isMaterialTabSelected &&
              editGrn && shipperApprovalPresent"
              @click="approve"
            >{{$t('INDENT_APPROVE')}}</Button>
          </div>
        </div>
      </div>
    </portal>
    <div>
      <ElTabs class="tab-default tab-sm text-dark" v-model="currentSelectedTab"
        @tab-click="setTabChangeGA()">
        <Tab-pane :label="$t('INDENT_DETAILS')" v-if="Object.keys(orderDetails).length" name="details">
            <div class="tab-content d-flex">
                <div class="bg-white" style="width:50%">
                    <div class="clearfix">
                      <Track
                        :indent="orderDetails"
                        :simTrackingEnabled="simTrackingEnabled"
                        :isSimTrackingAllowed="isSimTrackingAllowed"
                        :gpsTrackingEnabled="gpsTrackingEnabled"
                        :yetToTruckIn="yetToTruckIn"
                        :hasDriverAccepted="hasDriverAccepted"
                        :appTrackingEnabled="appTrackingEnabled"
                        :hyperTrackingEnabled="hyperTrackingEnabled"
                        :trackingAfterTruckOut="trackingAfterTruckOut"
                        :mapConfig="mapConfig"
                        @closeDrawer="closeDrawer" />
                    </div>

                    <Depot :order="orderDetails" :configurations="configurations" />
                    <Collapse v-model="activeName" accordion class="collapse-slider">
                        <CollapseItem title="Other Information" name="0"
                          v-if="showPurchaseOrderDetails || $hasFeature('weigh_bridge') ||
                          hasCustomFields">
                          <div class="flex-container panel-head align-top mb-15"
                            v-if="showPurchaseOrderDetails" >
                              <div class="flex-item floating">
                                <p v-bind:class="{'f-right text-right': ind%2}"
                                  v-for="(item, ind) in purchaseOrderFields" v-bind:key="ind">
                                  {{item.label}} :
                                  <strong>{{orderDetails.purchase_order_details[item.name]}}</strong>
                                </p>
                              </div>
                          </div>
                          <WeighInWeightOut
                            v-if="$hasFeature('weigh_bridge') && orderDetails"
                            :showActions="true"
                            :orderDetails="orderDetails"
                            :hideEdit="!showEditWeighBridge" />
                            <CustomField v-if="hasCustomFields"
                              :currentIndent="orderDetails"
                              :indentCustomFields="indentCustomFields"
                              :indentSourceCustomFields="indentSourceCustomFields"
                              :indentDestinationCustomFields="indentDestinationCustomFields"
                              :customFields="orderDetails.custom_fields" />
                        </CollapseItem>
                        <CollapseItem v-if="!isPackingIndentEnabled"
                            v-for="(source, index) in orderDetails.sources"
                            v-bind:key="source.unique_id"
                            :title="sourceHasGate(source.gate_id,source.location_id, source)"
                            :name="index">
                            <div class="flex-container panel-head align-top">
                              <div class="flex-item">
                                <p>
                                  {{$t('INDENT_REFERENCE_ID')}} :
                                  <strong>{{sourceHasGateRefrenceId(source.gate_id,source.location_id, source)}}</strong>
                                </p>
                                <p v-if="!hasDocks">
                                  {{$t('INDENT_LOADERS')}} :
                                  <strong>{{ source.loader_available ? $t('INDENT_YES') : $t('INDENT_NO')}}</strong>
                                </p>
                              </div>
                              <div class="flex-item text-right">
                                <p>
                                  {{$t('INDENT_VEHICLE_REQUIREMENT_DATE')}} :
                                  <strong>{{source.loading_date | moment("DD MMM YYYY")}}</strong>
                                </p>
                                <p v-if="!hasDocks && !dropoffsColumnsConfig.hide_paid_by">
                                  {{$t('INDENT_PAID_BY')}} :
                                  <strong>{{ source.add_to_invoice ? $t('INDENT_YES') : $t('INDENT_NO')}}</strong>
                                </p>
                              </div>
                            </div>
                            <Table
                              :data="source.gate_id ? getGateDestinations(source) : getSourceDestinations(source)"
                              :stripe="true"
                              align="top"
                              class="table-striped bordered my-15"
                              max-height="250px"
                              aria-describedby="documentDestiantionData"
                              >
                              <TableColumn :label="$t('INDENT_SHIPPED_TO')" width="210">
                                <template slot-scope="scope">
                                  <span v-if="!scope.row.consignmentNumber">
                                    <span class="d-block">{{scope.row.shipped_to}}</span>
                                    <Ellipsis class="text-xs" :text="getShippedToRefIdWithCity(scope.row)" :length="25" />
                                  </span>

                                  <span v-if="scope.row.consignmentNumber">
                                    <span class="d-block">{{scope.row.shipped_to}}</span>
                                    <Tooltip :open-delay="200" effect="dark" placement="bottom">
                                      <span class="pointer">
                                        <Ellipsis class="text-xs" :text="getShippedToRefIdWithCity(scope.row)" :length="25" />
                                      </span>
                                      <div slot="content">
                                        {{$t('INDENT_CONSIGNMENT_NUMBER')}} :{{scope.row.consignmentNumber}}
                                      </div>
                                    </Tooltip>
                                  </span>
                                </template>
                              </TableColumn>
                              <TableColumn :label="$t('INDENT_SOLD_TO')" width="210">
                                <template slot-scope="scope">
                                  <span class="d-block">{{scope.row.sold_to}}</span>
                                  <Ellipsis class="text-xs" :text="getSoldToRefIdWithCity(scope.row)" :length="25" />
                                </template>
                              </TableColumn>
                              <TableColumn prop="expected_date" :label="$t('INDENT_EXPECTED_DATE')" width="140" v-if="!dropoffsColumnsConfig.hide_expected_date">
                              </TableColumn>
                              <TableColumn prop="booking_date" :label="$t('INDENT_BOOKING_DATE')" width="140" v-if="$hasFeature('enable_booking_date')">
                              </TableColumn>
                              <TableColumn v-if="!dropoffsColumnsConfig.hide_unloaders" prop="unloaders" :label="$t('INDENT_UNLOADERS')" width="100">
                              </TableColumn>
                              <TableColumn v-if="!dropoffsColumnsConfig.hide_paid_by" prop="paid_by" :label="$t('INDENT_PAID_BY')">
                              </TableColumn>
                            </Table>
                          </CollapseItem>
                      </Collapse>
                </div>
                <div class="pl-20" style="width:50%">
                  <div class="timeline-multi timeline-right-default">
                    <Timeline :order="orderDetails"
                    :integrationTimeLine="integrationTimeLine"
                    :hideGateDetails="isReturnVendor"
                    :timeFormat="timeFormat" />
                  </div>
                </div>
            </div>
        </Tab-pane>
        <Tab-pane :label="$t('INDENT_MATERIAL_EPOD')" name="material">
          <material-epod-tab
            :showGrn="showGrn"
            :editGrn="editGrn"
            :showEditDeliveryNumbers="showEditDeliveryNumbers"
            :legalEntityDetails="legalEntityDetails"
            @routeToIndentsList="routeToIndentList"
            @setGA="setGA"
          ></material-epod-tab>
        </Tab-pane>
        <Tab-pane :label="$t('INDENT_FREIGHT_BIFURCATION')" name="bifurcation" v-if="showFreightWorkingDetails">
          <FreightCalculations selected="bifurcation"
            :orderDetails="orderDetails" />
        </Tab-pane>
        <Tab-pane :label="$t('INDENT_FREIGHT_CALCULATION')" name="calculation" v-if="showFreightWorkingDetails">
          <FreightCalculations selected="calculation"
            :orderDetails="orderDetails"
            :disableFreightProvisionRetry="disableFreightProvisionRetry"
            @retry-freight-provision="retryFreightProvision" />
        </Tab-pane>
        <Tab-pane :label="$t('INDENT_3D_VISUALIZATION')" name="visualize" v-if="show3dVisualization">
          <Visualize :isShowing="currentSelectedTab == 'visualize'" :orderDetails="orderDetails" />
        </Tab-pane>
      </ElTabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { uniq, uniqBy, omit } from 'lodash';
import { movementType, deliveryPendingReasonsMapping,
  movementType as movementListType, statusIdDictionary } from 'pando-constants';

import { Menu } from '@/constants/order';

import LrNumberInput from '@/modules-v2/indent/views/document/lr-number-input';
import MaterialDetails from '@/modules-v2/indent/views/document/material-details';
import MaterialEpodTab from '@/modules-v2/indent/views/document/material-epod-tab';
import TableCell from '@/components/orders/documentation/TableCell';
import FreightCalculations from '@/components/modules/freight/Page';
import Visualize from '@/components/modules/3d-visualization/visualize';
import Timeline from '@/components/orders/Timeline';
import Depot from '@/components/orders/Depot';
import WeighInWeightOut from '@/components/orders/WeightInWeighOut';
import Track from '@/components/orders/actions-v2/Track';

import CustomField from '@common/components/CustomField';
import AttachmentsMin from '@common/components/AttachmentsMin';
import AttachmentsPreview from '@common/components/AttachmentsPreview';
import AttachmentConstants from '@common/constants/AttachmentConstants';
import LrNumberListOnConfigMixin from '@common/mixins/document/LrNumberListOnConfigMixin';

export default {
  components: {
    AttachmentsMin,
    AttachmentsPreview,
    TableCell,
    LrNumberInput,
    FreightCalculations,
    MaterialDetails,
    MaterialEpodTab,
    Visualize,
    Timeline,
    Depot,
    WeighInWeightOut,
    CustomField,
    Track,
  },
  mixins: [LrNumberListOnConfigMixin],
  data() {
    return {
      // constants
      AttachmentConstants,
      isUploadInProcess: false,
      Menu,
      movementListType,
      currentSelectedTab: 'details',
      epod_not_clicked: true,
      showOtpPopup: false,
      otp: null,
      disableFreightProvisionRetry: false,
      legalEntityDetails: {},
      activeName: 0,
      types: { DEPOT: 1, CONSIGNEE: 2, VENDOR_DEPOT: 3 },
    };
  },
  async created() {
    this.category = this.$route.params.category;
    this.$store.commit('order/SET_ORDER', {});
    await this.loadLegalEntity();
  },
  computed: {
    ...mapGetters({
      orderDetails: 'order/find',
      isOrderLoading: 'order/isOrderLoading',
      configurations: 'app/configurations',
      filter: 'order/filter',

      isMaterialLoading: 'order/isMaterialLoading',
      allMaterials: 'order/materials',
      materialHeaders: 'order/materialHeaders',

      isLrLoading: 'order/isLrLoading',
      lr: 'order/lr',
      grnDetails: 'order/grnDetails',
      userEdited: 'order/userEdited',
      warnedOnce: 'order/warnedOnce',
      depots: 'app/otherDepots',

      deliveryDetails: 'order/deliveryNumberDetails',
      integrationTimeLine: 'order/integrationTimeLine',
      changeTruckComments: 'order/changeTruckComments',
      indentCustomFields: 'indentV2/indentCustomFields',
      indentSourceCustomFields: 'indentV2/indentSourceCustomFields',
      indentDestinationCustomFields: 'indentV2/indentDestinationCustomFields',
      purchaseOrderFields: 'indentV2/purchaseOrderFields',
      purchaseOrderConfig: 'indentV2/purchaseOrderConfig',
      trackingList: 'order/trackingList',
    }),
    hasCustomFields() {
      return (this.indentCustomFields && this.indentCustomFields.length) ||
        (this.indentSourceCustomFields && this.indentSourceCustomFields.length) ||
        (this.indentDestinationCustomFields && this.indentDestinationCustomFields.length);
    },
    isReturnVendor() {
      return this.orderDetails && this.orderDetails.movement === this.movementListType.INWARD;
    },
    dropoffsColumnsConfig() {
      return (this.configurations && this.configurations.dropoffs_columns_config) || {};
    },
    timeFormat() {
      return (this.configurations && this.configurations.is_datepicker_24H_enabled) ? 'HH:mm' : 'hh:mm A';
    },
    isFromEximList() {
      const isEximRoute = this.$route.query &&
        this.$route.query.isEximRoute;
      return isEximRoute === 'true';
    },
    showEditDeliveryNumbers() {
      const isMaterialsPresent = this.allMaterials && this.allMaterials.materials &&
        this.allMaterials.materials.length;
      const isConfigPresent = this.configurations && this.configurations.delivery_number_without_material_enabled;
      const isDeliveryDetailsPresent = this.orderDetails && this.orderDetails.delivery_numbers &&
        this.orderDetails.delivery_numbers.length;
      return !isMaterialsPresent && isConfigPresent && !isDeliveryDetailsPresent;
    },
    routeToIndentPath() {
      if (this.isFromEximList) {
        return { name: 'EximMasterIndent' };
      } else if (localStorage.getItem('controlTowerQueryParams')) {
        const controlTowerParams = JSON.parse(localStorage.getItem('controlTowerQueryParams'));
        if (parseInt(this.category, 10) === 1) {
          return { name: 'InboundIndentsV2',
            query: { metricType: controlTowerParams.metricType,
              depotId: controlTowerParams.depotId },
          };
        }
        return { name: 'OutboundIndentsV2',
          query: { metricType: controlTowerParams.metricType,
            depotId: controlTowerParams.depotId },
        };
      }
      if (parseInt(this.category, 10) === 1) {
        return { name: 'InboundIndentsV2' };
      }
      return { name: 'OutboundIndentsV2' };
    },
    isDispatched() {
      const orderStatus = this.orderDetails.status;
      return (
        this.$statusUtil.isDispatched(orderStatus) ||
        this.$statusUtil.isAfterDispatched(orderStatus)
      );
    },
    showFreightWorkingDetails() {
      const checkDelivered =
        this.orderDetails.status &&
        ['delivered', 'delivery_pending', 'dispatched'].includes(
          this.$statusUtil.getMainStatusName(this.orderDetails.status),
        );
      const hideFreightSettings = this.configurations.payment_settings &&
        this.configurations.payment_settings.hide_freight_working;
      return this.orderDetails.order_type !== 2 && checkDelivered && !hideFreightSettings;
    },
    show3dVisualization() {
      return this.orderDetails.optima_job_id && this.orderDetails.optima_link_id;
    },
    isMaterialTabSelected() {
      return this.currentSelectedTab === 'material';
    },
    /**
     * start of buttons and config check
     */
    showReTriggerEPOD() {
      if (
        this.configurations.erpEndPoint &&
        this.orderDetails.status === 23 &&
        this.orderDetails.delivery_pending_reason ===
          deliveryPendingReasonsMapping.EPOD_NA
      ) {
        return true;
      }
      return false;
    },
    showGrn() {
      if (this.inboundShowEditGRN) {
        return true;
      } else if (
        this.orderDetails.status === 23 ||
        this.orderDetails.status === 7 ||
        this.orderDetails.status === 6
      ) {
        return (
          this.orderDetails &&
          this.orderDetails.destinations &&
          this.orderDetails.destinations.some(
            destination => destination.release_at,
          )
        );
      }
      return false;
    },
    inboundShowEditGRN() {
      // currently assuming one source
      if (this.category === 1) { // condition for inbound
        if (this.orderDetails.status === 23
          || this.orderDetails.status === 6) { // inbound we show GRN in Delpending and dispatched
          return true;
        }
      }
      return false;
    },
    editGrn() {
      const indentConfig = this.configurations.indentConfig;
      let editGRN = false;
      const deliveryBlockSettings =
        indentConfig && indentConfig.grn_movement_delivery_block;
      const grnApprovalForTransporter =
        this.configurations.grnApprovalForTranporter;
      if (indentConfig && indentConfig.is_shipper_required_to_fill_grn) {
        let movementBlocked = false;
        if (grnApprovalForTransporter) {
          movementBlocked = true;
        }
        if (deliveryBlockSettings) {
          if (
            this.orderDetails.movement === movementType.PRIMARY &&
            deliveryBlockSettings.primary
          ) {
            movementBlocked = true;
          } else if (
            this.orderDetails.movement === movementType.SECONDARY &&
            deliveryBlockSettings.secondary
          ) {
            movementBlocked = true;
          } else if (
            this.orderDetails.movement === movementType.INWARD &&
            deliveryBlockSettings.vendor
          ) {
            movementBlocked = true;
          } else if (
            this.orderDetails.movement === movementType.RETURNS &&
            deliveryBlockSettings.return
          ) {
            movementBlocked = true;
          }
          if (movementBlocked) {
            editGRN = this.orderDetails.status === 23;
          }
        }
        editGRN = editGRN || this.inboundShowEditGRN;
      }
      return editGRN;
    },

    shipperApprovalPresent() {
      if (
        this.$hasFeature('grn_shipper_approval') &&
        this.$hasPermission('grn_approval') &&
        this.orderDetails.status === 23
      ) {
        return true;
      }
      return false;
    },

    canEnterOtp() {
      if (this.category == 1) {
        // condition for inbound
        return (
          this.$hasFeature('epod_otp_verification') &&
          this.orderDetails.status === 23 &&
          this.orderDetails.delivery_pending_reason ===
            deliveryPendingReasonsMapping.OTP_VERIFICATION
        );
      }
      return false;
    },
    hasMaterialInvoice() {
      const hasInvoice =
        this.allMaterials &&
        this.allMaterials.materials.some(material => material.invoice.number);
      return (
        hasInvoice && this.$hasFeature('avoid_manual_material_invoice_update')
      );
    },
    /**
     * end of buttons and config check
     */
    getMovement() {
      if (this.orderDetails) {
        if (this.orderDetails.movement === this.movementListType.RETURNS) {
          return 'Return';
        } else if (this.orderDetails.movement === this.movementListType.INWARD) {
          return 'Vendor';
        } else if (this.orderDetails.movement === this.movementListType.PRIMARY) {
          return 'Primary';
        }
        return 'Secondary';
      }
      return null;
    },
    /* start of track tab related methods */
    isSimTrackingAllowed() {
      const movement = this.getMovement.toLowerCase();
      return (this.configurations && this.configurations.track_settings &&
        this.configurations.track_settings[movement] &&
        this.configurations.track_settings[movement].enable_sim_tracking) || false;
    },
    gpsTrackingEnabled() {
      return Boolean(this.orderDetails && this.orderDetails.flow &&
        this.orderDetails.flow.gps_tracking &&
        this.orderDetails.flow.gps_tracking.is_enabled);
    },
    simTrackingEnabled() {
      return Boolean(this.orderDetails && this.orderDetails.flow &&
      this.orderDetails.flow.sim_tracking &&
        this.orderDetails.flow.sim_tracking.is_enabled);
    },
    yetToTruckIn() {
      return Boolean(this.orderDetails && this.orderDetails.sources &&
        this.orderDetails.sources.every(source => source.arrived_at === null));
    },
    trackingAfterTruckOut() {
      return Boolean(this.configurations && this.configurations.track_settings
        && this.configurations.track_settings.trip_creation_event === 'TRUCK_OUT');
    },
    hasDriverAccepted() {
      return Boolean(this.orderDetails && this.orderDetails.flow &&
      this.orderDetails.flow.driver_accepted);
    },
    hyperTrackingEnabled() {
      return !!(this.orderDetails.flow && this.orderDetails.flow.app_tracking &&
        this.orderDetails.flow.app_tracking.embed_url);
    },
    appTrackingEnabled() {
      return !!(this.orderDetails.flow && this.orderDetails.flow.app_tracking &&
        this.orderDetails.flow.app_tracking.track_trip_id);
    },
    trackTabTitle() {
      if (!this.yetToTruckIn && !this.simTrackingEnabled && this.hasDriverAccepted &&
      this.hyperTrackingEnabled) {
        return 'APP TRACK';
      }
      if (this.gpsTrackingEnabled || (this.isSimTrackingAllowed && this.simTrackingEnabled)
        || (this.appTrackingEnabled && this.hasDriverAccepted && !this.hyperTrackingEnabled)) {
        return 'TRACK';
      }
      return null;
    },
    mapConfig() {
      return (this.configurations && this.configurations.map_configuration);
    },
    /* end of track tab related methods */
    /* start of details tab methods */
    showEditWeighBridge() {
      return this.$hasFeature('weigh_bridge') && this.orderDetails &&
        this.$statusUtil.getStatusIds(['truck_arrived', 'loading_started', 'loading_ended']).includes(this.orderDetails.status) &&
        this.$hasPermission('update_weigh_bridge');
    },
    showPurchaseOrderDetails() {
      return this.orderDetails.purchase_order_details &&
        this.orderDetails.purchase_order_details.po_id && this.purchaseOrderConfig;
    },
    isPackingIndentEnabled() {
      return this.$hasFeature('packing_indent');
    },
    hasDocks() {
      return this.$hasFeature('docks');
    },
    /* end of details tab methods */
  },
  methods: {
    constructDestination(consignee) {
      const gateId = consignee.gate_id;
      const consignmentBooking = this.trackingList.length ? this.trackingList.find(
        consigneeTrack => gateId === consigneeTrack.consignee_id
          || consignee.location_id === consigneeTrack.consignee_id) : '';
      const soldDetails = (consignee.type === this.types.DEPOT) ? this.$depot.otherGate(consignee.sold_to_id, consignee.location_id) : consignee.sold_details;
      const result = {
        ref_id: (consignee.type === this.types.DEPOT) ? this.$depot.otherGate(consignee.gate_id, consignee.location_id).reference_id : consignee.details.reference_id,
        shipped_to: consignee.details.name,
        sold_to_ref_id: soldDetails && soldDetails.reference_id,
        sold_to: (consignee.type === this.types.DEPOT) ? consignee.details.name : soldDetails.name,
        unloaders: consignee.unloader_available ? 'Yes' : 'No',
        paid_by: consignee.add_to_invoice ? 'Yes' : 'No',
        expected_date: consignee.expected_delivery ?
          this.$moment(consignee.expected_delivery).format(
            'DD MMM YYYY',
          ) : '-',
        consignmentNumber: consignmentBooking
         && consignmentBooking.tracking_data && consignmentBooking.tracking_data[0]
         && consignmentBooking.tracking_data[0].tracking_id,
        sold_to_city: soldDetails && soldDetails.city,
        shipped_to_city: (consignee.type === this.types.DEPOT) ? this.$depot.otherGate(consignee.gate_id, consignee.location_id).city : consignee.details.city,
      };
      return result;
    },
    getGateDestinations(source) {
      const destinations = this.orderDetails.destinations;
      const gateId = source.gate_id;
      return destinations
        .filter(_destiantion => gateId === _destiantion.source_gate_id)
        .map(consignee => this.constructDestination(consignee));
    },
    getSourceDestinations(source) {
      const destinations = this.orderDetails.destinations;
      const locationId = source.location_id;
      return destinations
        .filter(_destiantion => locationId === _destiantion.source_location_id)
        .map(consignee => this.constructDestination(consignee));
    },
    sourceHasGateRefrenceId(gateId, locationId, source) {
      return gateId && source.type === this.types.DEPOT
        ? this.$depot.otherGate(gateId, locationId).reference_id
        : source.details.reference_id;
    },
    sourceHasGate(gateId, locationId, source) {
      return gateId && source.type === this.types.DEPOT
        ? this.$depot.otherGate(gateId, locationId).name
        : source.details.name;
    },
    getSoldToRefIdWithCity(data) {
      return data && data.sold_to_ref_id && data.sold_to_city ? `${data.sold_to_ref_id} - ${data.sold_to_city}` : data.sold_to_ref_id;
    },
    getShippedToRefIdWithCity(data) {
      return data && data.ref_id && data.shipped_to_city ? `${data.ref_id} - ${data.shipped_to_city}` : data.ref_id;
    },
    closeDrawer() {
      console.log('in close drawer');
    },
    cartonChange(cartons, deliveryId, fullDelivery = false, reshipAllStatus) {
      const existing = this.selectedCartons.get(deliveryId);
      const cartonCount = cartons && cartons.length;
      if (cartonCount > 0) {
        const proxy = this.selectedCartons;
        this.selectedCartons = new Map();
        proxy.set(deliveryId, {
          allSelected: reshipAllStatus ? fullDelivery : false,
          cartons,
        });
        this.selectedCartons = proxy;
      } else {
        const proxy = this.selectedCartons;
        this.selectedCartons = new Map();
        proxy.delete(deliveryId);
        this.selectedCartons = proxy;
      }
      if (reshipAllStatus && (cartonCount < existing && existing.cartons && existing.cartons.length)) {
        this.reShipProxyAllDeliveries = false;
      }
    },
    async loadLegalEntity() {
      try {
        const result = await this.$store.dispatch('order/getLegalEntity', {
          orderNo: this.$route.params.orderId,
        });
        if (!result || result.error) {
          this.$errorMessage({ message: 'Cannot load legal entity' });
        } else {
          this.legalEntityDetails = result;
        }
      } catch (err) {
        this.$errorMessage({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
    async retryFreightProvision() {
      try {
        this.disableFreightProvisionRetry = true;
        const result = await this.$store.dispatch('order/triggerFreightProvision', { orderId: this.orderDetails.order_number });
        if (result.status === 'Success') {
          this.$success({ message: this.$getSuccess('FREIGHT_PROVISION_SUCCESS') });
        } else {
          this.$error({ message: this.$getErr('RETRY_FAILED') });
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    routeToIndentList() {
      if (this.userEdited && !this.warnedOnce) {
        this.$warningMessage({ message: this.$getConst('EPOD_VALUE_CHANGED') });
        this.$store.commit('order/HAS_WARNED_ONCE', true);
      } else {
        this.$router.push(this.routeToIndentPath);
      }
    },
    /**
     * start of actions of buttons in material details tab
     */
    loadPlan() {
      const orderId = this.orderDetails.order_number;
      this.setGA('Click', 'Load Plan Button');
      this.$store.dispatch('order/loadPlan', orderId);
    },

    async uploadMaterial(event) {
      const attachment = event.target.files[0];
      const orderId = this.orderDetails.order_number;
      try {
        this.setGA('Click', 'Upload Button');
        const result = await this.$store.dispatch('order/uploadMaterials', {
          orderId,
          attachment,
        });
        if (result.error) {
          this.$error({ message: result.error });
        } else {
          if (result.valid_count >= 0) {
            await this.$store.dispatch('order/materials', {
              orderId: this.$route.params.orderId,
            });
            this.isUploadInProcess = !this.isUploadInProcess;
          }
          this.$success({
            message: `Uploaded count : ${result.valid_count} <br/> Unknown Materials count : ${result.invalid_count}`,
          });
        }
      } catch (error) {
        this.$error({
          message: 'Something went wrong! please try after some time',
        });
      }
    },

    downloadMaterial() {
      this.setGA('Click', 'Download Button');
      const orderId = this.orderDetails.order_number;
      this.$store.dispatch('order/downloadMaterial', { orderId });
    },

    async retriggerEpod() {
      try {
        this.setGA('Click', 'Re-Trigger ePOD');
        const res = await this.$store.dispatch('order/retriggerEpod', {
          orderNo: this.orderDetails.order_number,
        });
        if (res.status === 204) {
          this.$success({ message: 'EPOD TRIGGERED SUCCESSFULLY' });
          this.epod_not_clicked = false;
        } else {
          this.$error({ message: this.$getErr('RETRIGGER_EPOD_FAILED') });
        }
      } catch (err) {
        this.$error({ message: this.$getErr('RETRIGGER_EPOD_FAILED') });
      }
    },

    async approve() {
      try {
        this.setGA('Click', 'Approve Button');
        let orderConsignees = uniqBy(
          this.orderDetails.destinations,
          'location_id',
        );
        orderConsignees = orderConsignees.filter(
          consignee => consignee.release_at,
        );
        const promptText = this.$getConst('GRN_SUBMIT_PROMPT', {
          firstArgument: orderConsignees.length,
        });
        const buttontext = 'Approve';
        const confirmApprove = await this.confirmationBox(
          promptText,
          buttontext,
        );
        if (confirmApprove === 'confirm') {
          const orderNo = this.orderDetails.order_number;
          const consigneesIds = this.orderDetails.destinations.map(
            _destination => ({
              destination_id: _destination.location_id,
            }),
          );
          const result = await this.$store.dispatch('order/markDelivered', {
            orderNo,
            consigneesIds,
          });
          if (result.data && result.data.status === statusIdDictionary.delivered) {
            this.$success({ message: this.$getSuccess('GRN_SUBMIT_SUCCESS') });
          } else if (result.error) {
            this.$error({
              message: result.error,
            });
          }
          this.routeToIndentList();
        }
      } catch (err) {
        this.$error({ message: this.$getErr('GRN_SUBMIT_FAILED') });
      }
    },
    async submitOtp() {
      try {
        const orderNo = this.orderDetails.order_number;
        const otp = this.otp;
        const res = await this.$store.dispatch('order/approveOTP', {
          orderNo,
          otp,
        });
        if (res && res.status === 204) {
          this.$success({ message: 'OTP SUBMITTED SUCCESSFULLY' });
          this.routeToIndentList();
        } else {
          this.$error({ message: this.$getErr('OTP_FAILED') });
        }
      } catch (err) {
        this.$error({ message: this.$getErr('OTP_FAILED') });
      }
    },

    async saveDeliveryNumber() {
      try {
        // validate the payload
        const validPayload = this.deliveryDetails.every(val => val.source_id &&
          val.delivery_numbers && val.delivery_numbers &&
          ![val.delivery_numbers.charAt(0), val.delivery_numbers.charAt(val.delivery_numbers.length - 1)].includes(','));
        if (!validPayload) {
          this.$error({ message: this.$getErr('VALIDATION_ERROR') });
          return;
        }

        const orderNo = this.orderDetails.order_number;
        const payload = this.deliveryDetails.map((deliveryDetail) => {
          let detail = { ...deliveryDetail };
          const deliveryNumbersList = detail.delivery_numbers &&
            detail.delivery_numbers.split(',').map(val => val.trim());
          detail.delivery_numbers = uniq(deliveryNumbersList);
          detail = omit(detail, ['location_id']);
          return detail;
        });
        const result = await this.$store.dispatch('order/setDeliveryNumberDetails', {
          orderNo,
          payload,
        });
        if (result && !result.error) {
          this.$success({ message: this.$getSuccess('DELIVERY_NUMBER_UPDATE_SUCCESS') });
          const orderDetails = { ...this.orderDetails };
          orderDetails.delivery_numbers = result && result.delivery_numbers;
          this.$store.commit('order/SET_ORDER', orderDetails);
        } else {
          this.$error({ message: ((result && result.error) || this.$getErr('DELIVERY_NUMBER_UPDATE_FAILURE')) });
        }
      } catch (err) {
        this.$error({ message: this.$getErr('DELIVERY_NUMBER_UPDATE_FAILURE') });
      }
    },
    /**
     * end of actions of buttons in material details tab
     */

    async confirmationBox(text, buttonText) {
      return this.$PromptConfirm(text, 'Confirmation', {
        confirmButtonText: buttonText,
        showCancelButton: true,
        lockScroll: true,
        showClose: false,
        center: true,
      });
    },
    setTabChangeGA() {
      if (this.currentSelectedTab === 'bifurcation') {
        this.setGA('Click', 'Freight Bifurcation');
      } else if (this.currentSelectedTab === 'calculation') {
        this.setGA('Click', 'Freight Calculation');
      }
    },
    setGA(action, label) {
      this.$addGAEvent('Indent Management', action, `Documents:${label}`);
    },
  },
};
</script>
<style lang="scss">
.track {
  iframe {
    height: 400px;
  }
}
.map-container {
  width: 100% !important;
}
</style>
